import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CardFront from '../imgs/covers/landscaping1.jpg'
import CardBack from '../imgs/covers/landscaping2.jpg'

const styles = theme => ({
    container: {
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
        width: '100%'
    },
    title: {
        marginBottom: 30,
        color: '#393287'
    },
    p: {
        marginTop: 20,
        color: '#393287',
        fontSize: 16
    },
    p2: {
        marginTop: 0,
        color: '#393287'
    },
    ul: {
        marginBlockStart: 0
    },
    details: {
        paddingLeft: 10
    }
})

class Home extends React.Component{
    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid item md={4} sm={12}>
                    <Typography variant="title" className={classes.p}>
                        Landscape Design
                    </Typography>
                    <Typography variant="title" className={classes.p}>
                        We can help on:
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        <ul className={classes.ul}>
                            <li>Front Yard Design</li>
                            <li>Backyard Design</li>
                            <li>Garden Art & Decoration</li>
                            <li>Color in the Garden</li>
                            <li>Planting Ideas</li>
                            <li>Raised Bed Gardening</li>
                            <li>Natural Pools</li>
                        </ul>
                    </Typography>
                </Grid>
                <Grid item md={8} sm={12} className={classes.details}>
                    <img src={CardFront} className={classes.img}/>
                    {/* <img src={CardBack} className={classes.img}/> */}
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)